import setupSentry from './setup-sentry';

export default {
  setupSentry,
};
